import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_usaersetting() {
 const navigate = useNavigate();
      
        useEffect(() => {
          navigate('/user_management'); 
        }, [navigate]); 
      
        return null; 
}
